import styled from 'styled-components';
import { Row } from '@simplywallst/ui-core';
import { RouterLink, RouterLinkProps } from '@redux-first-router-link';
import { tabCSS, TabStyleType } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';

interface TabLinkProp extends RouterLinkProps {
  styleType: TabStyleType;
  selected: boolean;
}

export const TabLink = styled(RouterLink)<TabLinkProp>`
  ${tabCSS}
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DesktopSubNav = styled(Row)`
  margin-top: -${({ theme }) => theme.x1spacePx}px;
  border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
  position: sticky;
  top: ${({ theme }) => theme.desktopTopbarHeight}px;
  z-index: 99;
  background: ${({ theme }) => theme.color.charcoal};
`;

export const PageTitle = styled('h1')`
  ${({ theme }) => theme.typography.megaStrong}
  margin: ${({ theme }) => `${theme.x4spacePx}px 0`};
  ${media.lgUp`
    text-align: center;
  `};
  ${media.mdDown`
    margin-left: ${({ theme }) => theme.x2spacePx}px;
    margin-top: ${({ theme }) => theme.x2spacePx}px;
    margin-bottom: 0;
  `};
`;

export const CTA = styled('p')`
  ${({ theme }) => theme.typography.xSmall}
  margin: 0 auto;
  > svg {
    display: inline-block;
    margin-bottom: -${({ theme }) => theme.x1spacePx}px;
    margin-left: ${({ theme }) => theme.x1spacePx / 2}px;
    > * {
      fill: ${({ theme }) => theme.color.whiteRGBA(0.5)};
    }
  }
  ${media.lgUp`
    text-align: right;
  `};
  ${media.mdDown`
    margin-top: ${({ theme }) => theme.x1spacePx / 2}px;
    margin-bottom: ${({ theme }) => theme.x3spacePx}px;
    margin-left: ${({ theme }) => theme.x2spacePx}px;
  `};
`;
